<template>
    <div>
		<div v-if="parseInt(get_user.profile.total_deposit) > 0">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleLev)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h3 class="mb-4" v-if="!congModuleLev"> {{ $t('subticket_getSubPlan') }}</h3>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message---> 
				<!------------------request form-------------------------> 
				<div class="partcipate-fund CustomBlockWidth mb-3 " v-if="transaction_id == '' && !congModuleLev && subPlanDetail != ''">
					<div class="row justify-content-center no-gutters">
						<div class="col-lg-8">
							<div class="whiteBG p-3">
								<div class="mb-3 " > 
									<div class="selectPlan mb-3">
										<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
											<h4>{{subPlanDetail[0].plan_type}}</h4>
											<div class="price" >
												&dollar; {{planDetailData.amount}} {{ $t('subscription_mnth') }}
											</div>
										</div>
									</div>
									<div class="selectPlan mb-3" v-if="coupon_apply">
										<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
											<h4 class="d-flex align-items-center">{{$t('subticket_applyCouponCode')}} 
												<div class="couponapplied ml-2">
													<div class="appliedcouponcode">
														<span>{{coupon_code1}}</span>
													</div>
												</div>
											 </h4>
											<div class="price" >
												&dollar; {{coupon_price}}
											</div> 
										</div>
										<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
											<h4>{{$t('subticket_TotalAmount')}}</h4>
											<div class="price">
												&dollar; {{amount}}
											</div>
										</div>
									</div>
									 
									<!-------------------have a promocode section---------------------------------------------->
									<div class="promocode d-flex align-items-center justify-content-start" v-else>   
										<!--<div class="couponapplied" v-if="couponapplied">
											<div class="appliedcouponcode">
												<span>{{coupon_code}}</span>
												<span>{{counpon_price2}}</span>
												<span>{{amount}}</span>
												<feather type="x" @click.prevent="applycoupon('','remove')" v-if="couponapplied"></feather>
											</div>
											<div class="appliedcoupon">
												<p>{{coupon_code}}  {{ $t('appliedmnth') }}</p>
											</div> 
										</div> -->
										<div class="selectPlan mb-3 w-100" v-if="couponapplied">
											<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
												<h4 class="d-flex align-items-center">{{$t('subticket_applyCouponCode')}} 
													<div class="couponapplied ml-2">
														<div class="appliedcouponcode">
															<span>{{coupon_code}}</span>
															<feather type="x" @click.prevent="applycoupon('','remove')" v-if="couponapplied" size="1em"></feather>
														</div>
													</div>
												 </h4>
												<div class="price" >
													&dollar; {{counpon_price2}}
												</div> 
											</div>
											<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
												<h4>{{$t('subticket_TotalAmount')}}</h4>
												<div class="price">
													&dollar; {{amount}}
												</div>
												
											</div>
										</div>
										<a class="haveacode" v-else href="#" v-on:click.prevent="show_coupon_list=true; getcouponList() ; coupon_code_validity = ''"> {{ $t('subticket_havePromoCode') }}</a> 
									</div> 
									<!---------------------------------------------------------------------------------------->
								</div>
								<div class="p-0 mb-0" >
									<p> {{$t('subticket_deducedMonthlySubscription')}} </p> 
								</div>
								<div class=" mb-3 "> 
									<div class="form-group field-wrapper">
										<div class="customSelect mdb-select md-form float-field form-control" @click.prevent="selectAccount = !selectAccount" :class="(selectAccount?'active' : '')">
											<div class="SelectAcntList">
												<div class="d-flex align-items-center justify-content-between" v-if="account_id == ''">
												<p> {{ $t('accId_selectAccountId') }}</p></div>
												<div class="d-flex align-items-center justify-content-between" v-else>
													<span v-if="getWallet(account_id)">
														<img :src="'../../../../static/fxView/images/'+getWallet(account_id).wallet.currency.toLowerCase()+'.svg'" class="mr-2" alt="Icon">
														{{getWallet(account_id).wallet.wallet_no}} 
													</span>
													<span v-else>
														<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[platform]" class="mr-2" alt="Icon">
														{{account_id}} 
													</span>
													<small v-html="(parseInt(demo_live) == 1)? $t('subticket_live') : $t('subticket_demo') "></small>
												</div>
											</div>
											<ul class="scrollbar" ><!---->
												<li v-for="(list,key) in allAccountList.records" v-if="parseInt(list.demo_live) == 1" @click.prevent="asignValueParentComponent(list)" >
													<div class="aclist" v-if=" list.margin_detail"> 
														<span>
															<img :src="'../../../../static/fxView/images/'+list.currency.toLowerCase()+'.svg'" class="mr-2"  alt="Icon"> {{list.wallet_no}}  
														</span>
													</div>
													<div class="aclist" v-else> 
														<span>
															<img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
														</span>
														<small v-html="(parseInt(list.demo_live) == 1)? $t('subticket_live') : $t('subticket_demo') "></small>
													</div>
												</li>
											</ul>
										</div>
										<input type="hidden" v-model="account_id"  v-validate="{ required: true }" name="account_id" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('account_id') }" ref="account_idInput" required>
										<ul><li v-for="error in errors.collect('account_id')" class="error">{{$t('req_fieldReq')}}</li></ul>
									</div> 
									<div class="mb-3" >
										<p> {{ $t('subticket_noteUnsubTool') }}</p>
									</div>
									<div class="clearfix"></div> 
									<div class="text-center d-flex align-items-center justify-content-between"> 
										<div class="form-group field-wrapper mb-0">
					                        <label class="text-left fancy_radiochk_btn mb-0"> {{$t('subticket_clickToAgree')}} <a href="../../../../static/fxView/pdf/FXVIEW_VPS_T&C.pdf" target="_blank">{{$t('subticket_vpsTC')}}</a>
					                            <input type="checkbox" v-model="agree1" value="1"  v-validate="{ required: true }" name="agree1" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('agree1') }" ref="agree1Input" required><span class="checkmark"></span>
												<ul><li v-for="error in errors.collect('agree1')" class="error">{{$t('req_fieldReq')}}</li></ul>
					                        </label>
					                    </div>
										<button class="prism_btn btn_sm" v-on:click.prevent="submitChangeLeverageRequestOtp()"> {{ $t('sub_subscribe') }}</button> 
									</div> 
								</div>
							</div>
						</div>
					</div>	 
				</div> 
				<!----------------------------------------------------->
				<div class="partcipate-fund CustomBlockWidth mb-3" v-if="transaction_id != '' && !congModuleLev">
					<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
						<div class="row justify-content-center no-gutters">
							<div class="col-lg-8">
								<div class="whiteBG p-4 mb-3" >  
									<div class="selectPlan mb-3">
										<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
											<h4>{{subPlanDetail[0].plan_type}}</h4>
											<div class="price" >
												&dollar; {{planDetailData.amount}}{{ $t('mnth') }}
											</div>
										</div>
									</div> 
									
									<div class="selectPlan mb-3" v-if="coupon_apply">
										<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
											<h4 class="d-flex align-items-center">{{$t('subticket_applyCouponCode')}} 
												<div class="couponapplied ml-2">
													<div class="appliedcouponcode">
														<span>{{coupon_code1}}</span>
													</div>
												</div>
											 </h4>
											<div class="price" >
												&dollar; {{coupon_price}}
											</div> 
										</div>
										<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
											<h4>{{$t('subticket_TotalAmount')}}</h4>
											<div class="price">
												&dollar; {{amount}}
											</div>
										</div>
									</div>
									
									<div class="promocode d-flex align-items-center justify-content-start" v-else> 
										<div class="selectPlan w-100 mb-3" v-if="couponapplied">
											<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
												<h4 class="d-flex align-items-center">{{$t('subticket_applyCouponCode')}}
													<div class="couponapplied ml-2">
														<div class="appliedcouponcode">
															<span>{{coupon_code}} <feather type="x" @click.prevent="applycoupon('','remove')" v-if="couponapplied"  size="1em"></feather></span>
														</div>
													</div>
												 </h4>
												<div class="price" >
													&dollar; {{counpon_price2}}
												</div> 
											</div>
											<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
												<h4>{{$t('subticket_TotalAmount')}}</h4>
												<div class="price">
													&dollar; {{amount}}
												</div>
												
											</div>
										</div>
										<!--<div class="couponapplied" >
											<div class="appliedcouponcode">
												<span>{{}}</span>
												
											</div>
											<div class="appliedcoupon">
												<p>{{coupon_code}}{{ $t('appliedmnth') }}</p>
											</div> 
										</div> -->
										<a class="haveacode" v-else href="#" v-on:click.prevent="show_coupon_list=true; getcouponList() ; coupon_code_validity = ''">{{ $t('subticket_havePromoCode') }}</a> 
									</div>
								</div>
							</div>
						</div> 
						<div class="row justify-content-center no-gutters">
							<div class="col-lg-8">
								<div class="whiteBG p-4">
									<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
									<div class="form-group field-wrapper">
										<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedOtp && errors.has('otp') }" ref="otpInput">
										<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
									</div> 
									<div class="form-group text-center field-wrapper">
										<button class="prism_btn btn_sm " v-on:click.prevent="submitChangeLeverageCheckOtp()">{{$t('rb_validate')}} </button>
									</div>
									<div class="clearfix"></div>
									<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
										<div class="desc text-center">
											<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
										</div>
									</div>
									<div class="clearfix"></div>
								</div> 
							</div>
						</div>
					</div>
					<div class="row justify-content-center no-gutters">
						<div class=" middleBox">
							<div class="whiteBG p-4"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
								<div class="congratulations">
									<div class="logo_congrats">
										<img src="../../../../static/fxView/images/leverage.svg" alt="Icon">
									</div>
									<div class="subtitle">
										<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}}</strong>
											{{$t('rb_googleAuth6')}} <strong>{{get_user.email}} . </strong>  {{ $t('subticket_linkToSub') }}
										</p>
										<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
									</div>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
									<div class="ico mr-3">
										<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
									</div>
									<div class="desc w-75">
										<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
										<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!---------------------congo-message-------------->
				<div class="CustomBlockWidth whitebox mb-3 inMiddle-area p-4 stepForm" v-if="congModuleLev">
					<div class="congratulations">
						<div class="logo_congrats">
							<img src="../../../../static/fxView/images/check.svg" alt="Icon">
						</div>
						<div class="subtitle">
							<h3>{{$t('rb_congo')}} <span class="green">{{get_user.username}}</span></h3>
							<p>{{subPlanDetail[0].plan_type}} {{ $t('subticket_subsucce') }}</p> 
						</div>
						<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
							<router-link :to="'/tools/AutoChartist-Scanner'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 1"> {{ $t('subticket_AutoChartPage') }}</router-link>
							<router-link :to="'/tools/Signals'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 2"> {{ $t('subticket_controlsignalPage') }}</router-link>
							<router-link :to="'/tools/Economic-Calendar'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 4"> {{ $t('subticket_researchReportpage') }}</router-link>
							<router-link :to="'/research-and-education/News'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 3"> {{ $t('subticket_currentNewsPage') }}</router-link>
							<router-link :to="'/tools/Economic-Calendar'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 5"> {{ $t('subticket_economicCalPage') }}</router-link>
							<router-link :to="'/tools/VPS'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 6">{{ $t('subticket_vpsPage') }}</router-link>
						</div>
					</div> 
				</div>
				 
				<!-----------------------------section display when i click on have a  promocode-------------------------->
				<section class="costompopup pop_sm1" v-if="show_coupon_list">
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<div class="middleBox  platfromBox"> 
						<div class="darkBG platfromBox_title p-3">  
							<h4 class="mb-0">{{ $t('subticket_selectPromoCode') }}</h4>
							<feather class="close" v-on:click.prevent="show_coupon_list = false" type="x"></feather>
						</div>
						<div class="p-4">
							<div class="row">
								<div class="col-12 col-md-8">
									<input type="text" :placeholder="$t('subticket_EnterCouponCode')" v-model="coupon_code_validity" class="form-control">		
								</div>
								<div class="col-12 col-md-4">
									<button class="prism_btn btn_sm w-100" @click.prevent="checkCouponCode()" :class="(coupon_code_validity == '')? 'disabled' : ''"> {{ $t('subticket_Apply') }}</button>
								</div>
							</div>
						</div> 
						<div class="couponDesc scrollbar" > 
							<div v-if="couponList.length > 0">
								<div class="selectPro d-flex align-items-center justify-content-between p-3 border-top " v-for="coupon in couponList ">
									<div class="desc">
										<strong class="green">{{coupon.code}}</strong>
										<p class="description">{{coupon.description}} {{ $t('subticket_For') }}  {{coupon.period}} </p>
									</div>
									<button class="prism_btn btn_sm" @click.prevent="applycoupon(coupon,'apply')" v-if="!couponapplied">{{ $t('subticket_Apply') }}</button>
								</div>
							</div>
							<div class="p-5 border-top text-center" v-else>
								<p class="red">{{$t('subticket_noPromoCode')}}</p>
							</div>
						</div>
						
					</div>
				</section> 
				<!------------------------------------------------------------------------------------------------------------>
			</div>
		</div>
		<div class="partcipate-fund CustomBlockWidth inMiddle-area mb-3" v-if="parseInt(get_user.profile.total_deposit) == 0">
			<div class="mainTitle text-center mt-4 mb-3">
				<h3 class="mb-4">{{$t('subticket_vpsSubPlan')}}</h3>
			</div>
			<div class="whitebox text-center p-4 mb-3">  
				<img src="../../../../static/fxView/images/fund_deposit.svg" alt="add fund" class="mb-3" width="250">
				<p class="mb-2">{{$t('subticket_createVPS')}}</p>
				<router-link to="/account-funding" class="prism_btn btn_sm"  data-placement="top"  data-toggle="tooltip">
					{{$t('subticket_goDepositPage')}}
				</router-link> 
			</div>
		</div>
		
		<div class="text-center CustomBlockWidth">
			<router-link to="/tools/VPS" class="underline" title="subscribe" data-placement="top"  data-toggle="tooltip">back</router-link>
		</div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Create-Subscription-Ticket',
        mixins: [fxViewMixins],
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,
                exsisting_leverage : '',
				coupon_code_validity : '',
                account_id_leverage : '',
                submitted : false,
				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				//------------------------
                otp : '',
                submittedOtp : false,
                transaction_id : '',

                congModuleLev : false,
                authComponent : false,
                request_page : 'accounts',
                show_coupon_list: false,
                coupon_code: -1,
				counpon_price2 : '',
                couponapplied: false,
                amount: 0,
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				planDetailData : '',
				
				
				coupon_apply : false,
				coupon_code1 : -1,
				coupon_price : '',
				agree1 : ''
            }
        },
        methods:{
        	getWallet(account_id){// to check if the trading account_id is wallet also return wallet id and also need to get wallet id and currency
        		try{
	        		let data = Object.values(this.walletAccount).filter(val=> val.wallet.account_id == account_id )
	        		return (data.length)?data[0]:''
        		}catch(e){return '';}
        	},
        	maxDate(){
	           	return moment().format('YYYY-MM-DD');
	        },
			asignValueParentComponent(list){
				this.account_id = list.account_id 
				this.act_account_id = list.act_account_id  
				this.demo_live = list.demo_live 
				this.platform = list.platform 
		    },
			reset(){
                this.selectAccount = false,
                this.account_id = ''
				this.act_account_id = ''
				this.demo_live = ''
				this.platform =''
                this.submitted = false
            },
			
			submitChangeLeverageRequestOtp(){
				const _that = this
				this.submitted = true
				let coupon_code = -1
				if(this.coupon_apply){
					coupon_code = this.coupon_code1
				}else if(this.couponapplied){
					coupon_code = this.coupon_code
				}
				_that.$validator.validate().then(valid => {
                    if (valid) {
						let input_json={
							'globalParams' :{
								'account_id' : _that.account_id ,
								"act_account_id" : _that.act_account_id,
								"plan_id" : _that.$route.query.plan_id,
								"detail_id" : _that.planDetailData.id,
								'operation' : _that.subPlanDetail[0].plan_type,
								"couponcode": coupon_code
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runSubOperation(input_json)
					}
				})
            },
            submitChangeLeverageCheckOtp(){
                const _that = this
                this.submittedOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that , "plan_id" : _that.$route.query.plan_id,"detail_id" : _that.planDetailData.id, }
                        }
                        _that._runCreateSubTicket(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
			resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runSubOperLink(input_json)
            },
			
			
			//when click on have a promocode
            getcouponList(){
                // RUN_GET_COUPON_LIST
                const _that = this
                let input_json={
                    'globalParams' :{
                        "plan_id" : _that.$route.query.plan_id
                    },
                    'localParams' :{ "parameter" : _that }
                }
                _that._runGetCouponList(input_json)
            },
			checkCouponCode(){
				let input_json={
                    'globalParams' :{
                        "coupon_code" : this.coupon_code_validity
                    },
                    'localParams' :{ "parameter" : this }
                }
                this._runCheckCouponValidity(input_json)
			},
			applycoupon(couponlist,getData){
				if(getData == 'apply'){
					this.coupon_code = couponlist.code
					this.counpon_price2 = couponlist.discount_amount
					if(parseInt(couponlist.is_fixed)){
						this.amount = this.amount - couponlist.discount_amount
					}else{
						this.amount = this.amount - ((this.amount * couponlist.discount_amount)/100)
					}
					this.couponapplied = true
					this.show_coupon_list= false
				}else{
					this.couponapplied = false
					this.amount = this.planDetailData.amount
				}
				
            },
			
            
			userDepositFunc(){
				this.detailPLanCoupon()
			},
			detailPLanCoupon(){
				let input_json={
					'globalParams' :{
						'plan_id' : this.planDetailData.id ,
					},
					'localParams' :{ "parameter" : this }
				}
				this._runCouponPlan(input_json)
			},
        },
        components: {
            appTwofa: twoFa
        },
        created(){
			let input_json={
				'globalParams' :{
					'plan_id' : this.$route.query.plan_id
				},
				'localParams' :{ "parameter" : this , 'plan_detail_id' : this.$route.query.plan_detail_id , 'page' : 'create_plan_ticket'}
			}
			this._runGetSubPlanDetail(input_json)
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList').length){
                    _that.selectAccount = false
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/createSubTicket.vue